module.exports = __webpack_public_path__ + "ar.dce465a98e8efcea5e2b064d8cada0aa.png";